//Paymentsuccess page

import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import '../Payments/paymentsuccess.css'
import { getMethod } from '../../../services/apiService';

export const PaymentSuccess = () => {
  const [paymentData, setPaymentData] = useState({});
  const [statusType, setStatusType] = useState(null);
  const location = useLocation();

  //decryption
  useEffect(() => {
    const fetchDecryptedData = async () => {
      const queryParams = new URLSearchParams(location.search);
      const encryptedData = queryParams.get('data');
      try {
        const res = await getMethod(`decrypt-payment?data=${encryptedData}`);
        if (res?.status && res.data) {
          setPaymentData(res.data);
          if (res.data.payment_status === "paid") {
            setStatusType("success");
          } else {
            setStatusType("failure");
          }
        } else {
          setStatusType("failure");
        }
      } catch (err) {
        console.error("API error", err)
        setStatusType('failure')
      }
    }
    fetchDecryptedData()
  }, [location]);

  return (
    <div className="payment-success-card">
      <h2>
        {statusType === 'failure' ? '❌ Payment Failed' : '✅ Payment Success'}
      </h2>

      <div className="info-row">
        <div className="label">Order ID:</div>
        <div className="value">{paymentData.order_id}</div>
      </div>

      <div className="info-row">
        <div className="label">Payment ID:</div>
        <div className="value">{paymentData.payment_id}</div>
      </div>

      <div className="info-row">
        <div className="label">Status:</div>
        {paymentData?.payment_status && (
          <div
            className={`value status-text ${paymentData.payment_status === 'paid' ? 'text-green' : 'text-red'
              }`}
          >
            {paymentData.payment_status === 'paid' ? 'Paid' : 'Failed'}
          </div>
        )}
      </div>
    </div>

  );
};
